import React from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
import componentQueries from "react-component-queries";

const Player = styled(ReactPlayer)`
  iframe {
    width: 100%;
  }
`;

const Error = styled.div`
  height: ${({ height }) => height}px;
  width: 100%;
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

export default componentQueries(({ width }) => {
  return {
    width
  };
})(
  class extends React.Component {
    state = {
      error: false
    };

    onError = () => {
      this.setState({
        error: true
      });
    };

    render() {
      const { content, width } = this.props;
      const scale = width / content.width;
      if (this.state.error) {
        return (
          <Error width="100%" height={content.height * scale}>
            Error loading video :(
          </Error>
        );
      }
      return (
        <Player
          width={"100%"}
          height={content.height * scale}
          url={content.url}
          onError={this.onError}
        />
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/video.js